import isEmpty from 'lodash/isEmpty';
import UserDatabases from '@Services/UserDatabases';
import { isAPIError } from '@Containers/CasNumber/utils';
import Catalyst from '@Services/Catalyst';

const trackDisplayedCtas = (displayedCtas) => {
  if (isEmpty(displayedCtas)) {
    return;
  }

  Catalyst.trackEvent('widgetImpression', {
    link: {
      widgetNames: ['Retrieve CAS RN'],
      name: 'Retrieve CAS RN',
      type: 'cas-api',
    },
    content: displayedCtas.map(({ substanceId, databaseId }) => ({
      id: `${UserDatabases.getDbName(databaseId)}:${substanceId}`,
    })),
  });
};

const debounceTrackDisplayedCtas = (delay = 0) => {
  let displayedCtas = [];
  let timeoutId;

  return ({ substanceId, databaseId }) => {
    displayedCtas.push({ substanceId, databaseId });
    window.clearTimeout(timeoutId);
    timeoutId = window.setTimeout(() => {
      trackDisplayedCtas(displayedCtas);
      displayedCtas = [];
    }, delay);
  };
};

export const onCtaMounted = debounceTrackDisplayedCtas();

export const onFetchCasNumber = ({ substanceId, databaseId, withCta }) => {
  const databaseName = UserDatabases.getDbName(databaseId);

  Catalyst.trackEvent('contentAdditionStart', {
    link: {
      name: withCta ? 'Retrieve CAS RN' : 'Show details',
      type: 'cas-api',
    },
    content: [
      {
        id: `${databaseName}:${substanceId}`,
      },
    ],
  });
};

export const onFetchCasNumberSuccess = ({ substanceId, databaseId, withCta, casNumber }) => {
  const databaseName = UserDatabases.getDbName(databaseId);

  Catalyst.trackEvent('contentAddition', {
    link: {
      name: withCta ? 'Retrieve CAS RN' : 'Show details',
      type: 'cas-api',
    },
    content: [
      {
        id: `${databaseName}:${substanceId}`,
        id2: `cas-api:${casNumber}`,
      },
    ],
  });
};

export const onFetchCasNumberError = ({ substanceId, databaseId, withCta, errorNumber, errorMessage }) => {
  const databaseName = UserDatabases.getDbName(databaseId);
  const errorType = `${isAPIError(errorNumber) ? 'se' : 'ae'}:${errorMessage}`;

  Catalyst.trackEvent('formError', {
    form: {
      errorType,
      link: {
        name: withCta ? 'Retrieve CAS RN' : 'Show details',
        type: 'cas-api',
      },
      content: [
        {
          id: `${databaseName}:${substanceId}`,
        },
      ],
    },
  });
};
